var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 36,
    viewBox: "0 0 53 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5825 15.4165L37.5891 11.2184H37.4579H37.3266L23.3332 15.4165C23.1583 15.4602 23.0272 15.6351 23.0272 15.8538C23.0272 16.0724 23.1584 16.2037 23.3332 16.2911L37.3266 20.4891C37.414 20.5328 37.5016 20.5328 37.589 20.4891L51.5824 16.2911C51.7573 16.2474 51.8884 16.0724 51.8884 15.8538C51.8886 15.6351 51.7573 15.4602 51.5825 15.4165Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8912 15.6037V27.8439L37.5309 23.3223V11.1161L51.8912 15.6037Z",
    fill: "#8C187D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.531 11.2957V23.502L22.9912 27.8101V15.4243L37.531 11.2957Z",
    fill: "#DA85CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5825 27.5512L37.5891 23.3532H37.4579H37.3266L23.3332 27.5512C23.1583 27.5949 23.0272 27.7699 23.0272 27.9885C23.0272 28.2072 23.1584 28.3384 23.3332 28.4258L37.3266 32.6238C37.414 32.6675 37.5016 32.6675 37.589 32.6238L51.5824 28.4258C51.7573 28.3821 51.8884 28.2072 51.8884 27.9885C51.8886 27.7699 51.7573 27.5949 51.5825 27.5512Z",
    fill: "#C125AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5956 11.1393L37.4579 6.98501L51.3201 11.1393C51.5387 11.2267 51.801 11.0956 51.8447 10.8332C51.9321 10.6146 51.801 10.3523 51.5387 10.3086L37.5453 6.11055H37.414H37.2828L23.2894 10.3086C23.0708 10.396 22.9395 10.6146 22.9834 10.8332C23.1146 11.0518 23.377 11.183 23.5956 11.1393Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5956 10.6262L37.4579 6.47194L51.3201 10.6262C51.5387 10.7136 51.801 10.5825 51.8447 10.3202C51.9321 10.1015 51.801 9.8392 51.5387 9.79551L37.5453 5.59749H37.414H37.2828L23.2894 9.79551C23.0708 9.88291 22.9395 10.1016 22.9834 10.3202C23.1146 10.5387 23.377 10.6699 23.5956 10.6262Z",
    fill: "#666666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5952 5.54176L37.4574 1.38747L51.3196 5.54176C51.5382 5.62916 51.8006 5.49806 51.8443 5.23571C51.8879 4.97337 51.8006 4.75473 51.5382 4.71104L37.5448 0.513017H37.4136H37.2823L23.2889 4.71104C23.0703 4.79844 22.939 5.01708 22.9829 5.23571C23.0267 5.45435 23.3766 5.62932 23.5953 5.54176H23.5952Z",
    fill: "#666666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5952 5.0287L37.4574 0.874412L51.3196 5.0287C51.5382 5.1161 51.8006 4.985 51.8443 4.72265C51.8879 4.4603 51.8006 4.24167 51.5382 4.19797L37.5448 -4.43459e-05H37.4136H37.2823L23.2889 4.19797C23.0703 4.28537 22.939 4.50402 22.9829 4.72265C23.0267 4.94128 23.3766 5.11625 23.5953 5.0287H23.5952Z",
    fill: "#666666"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.7158,
    cy: 4.76361,
    rx: 0.769565,
    ry: 0.65339,
    transform: "rotate(-15 23.7158 4.76361)",
    fill: "#666666"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.769565,
    cy: 0.672085,
    rx: 0.769565,
    ry: 0.672085,
    transform: "matrix(-0.963755 -0.266789 -0.251054 0.967973 52.1575 4.34399)",
    fill: "#666666"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.7158,
    cy: 10.4072,
    rx: 0.769565,
    ry: 0.65339,
    transform: "rotate(-15 23.7158 10.4072)",
    fill: "#666666"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.769565,
    cy: 0.672085,
    rx: 0.769565,
    ry: 0.672085,
    transform: "matrix(-0.963755 -0.266789 -0.251054 0.967973 52.1575 9.98743)",
    fill: "#666666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5448 23.6118L10.4896 20.5953H10.3953H10.301L0.245831 23.6118C0.120121 23.6432 0.0259171 23.7689 0.0259171 23.9261C0.0259171 24.0832 0.120226 24.1775 0.245831 24.2403L10.301 27.2568C10.3638 27.2882 10.4267 27.2882 10.4895 27.2568L20.5447 24.2403C20.6704 24.2089 20.7646 24.0832 20.7646 23.9261C20.7648 23.7689 20.6704 23.6432 20.5448 23.6118Z",
    fill: "#D9D9D9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7666 23.7463V32.5417L10.4478 29.2927L10.4478 20.5217L20.7666 23.7463Z",
    fill: "#8C187D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4478 20.6508L10.4478 29.4218L-6.86646e-05 32.5175L-6.86646e-05 23.6175L10.4478 20.6508Z",
    fill: "#DA85CF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5448 32.3314L10.4896 29.3149H10.3953H10.301L0.245831 32.3314C0.120121 32.3628 0.0259171 32.4886 0.0259171 32.6457C0.0259171 32.8028 0.120226 32.8971 0.245831 32.9599L10.301 35.9764C10.3638 36.0079 10.4267 36.0079 10.4895 35.9764L20.5447 32.9599C20.6704 32.9285 20.7646 32.8028 20.7646 32.6457C20.7648 32.4886 20.6704 32.3628 20.5448 32.3314Z",
    fill: "#C125AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cdabc0a9b73b597f242439c7a366d521.svg";
export { ForwardRef as ReactComponent };